import { useEffect } from "react";
import useTranslate from "../../../hooks/useTranslate";
import { Column } from "@tanstack/react-table";
import { TextfieldWithAutocomplete } from "../../../ui";
import { useForm } from "../../../hooks";

interface ITableFilter<T> {
	table: any;
	column: Column<T, unknown>;
	options: string[];
	rowSelection: Record<string, boolean>;
}

const TableFilter = <ColumnType,>({ options, rowSelection, table, column }: ITableFilter<ColumnType>) => {
	const { values, onChange, setValues } = useForm({ filter: "" });
	const translate = useTranslate(); // hook для перевода текста
	const uniqueOptions = options ? Array.from(new Set([...options, ""])) : []; // Удаляем дубликаты из options

	useEffect(() => {
		Object.keys(rowSelection).length > 0 && table.resetRowSelection(); // если выбраны строки - сбрасываем
		// фильтруем через пол-секунды бездействия после окончания ввода значения для фильтрации
		const handler = setTimeout(() => {
			column.setFilterValue(values.filter);
		}, 500);

		return () => {
			clearTimeout(handler); // сбрасываем timeout, если продолжается ввод значения для фильтрации
		};
	}, [values.filter]);

	return (
		<TextfieldWithAutocomplete
			autocompleteOptions={uniqueOptions}
			value={values.filter}
			values={values}
			setValues={setValues}
			freeSolo
			sx={{ mb: "8px" }}
			name={"filter"}
			onChange={onChange}
			label={translate("input_filter")}
		/>
	);
};

export default TableFilter;
